// extracted by mini-css-extract-plugin
module.exports = {"holder":"_vGA6s1","close":"_3WDqrvr"};